export const formValidationMixins = {
  methods: {
    isInvalid (field, type = 'text') {
      if (type === 'text') {
        if (!field || field.length < 2) return true
      } else if (type === 'password') {
        if (!field || field.length < 8) return true
      } else if (type === 'email') {
        // eslint-disable-next-line
        const result = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(field)
        return !result
      } else if (type === 'tel') {
        // eslint-disable-next-line
        const result = /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/im.test(field)
        return !result
      } else if (type === 'number') {
        // eslint-disable-next-line
        const result = /^\d+$/.test(field)
        return !result
      } else if (type === 'code_postal') {
        // eslint-disable-next-line
        const result = /^(?:(?:(?:0[1-9]|[1-8]\d|9[0-5])(?:\d{3})?)|97[1-8]|98[4-9]|2[abAB])$/.test(field)
        return !result
      } else if (type === 'iban') {
        // eslint-disable-next-line
        // const result = /^[A-Z]{2}[0-9]{2}(?:[ ]?[0-9]{4}){4}(?:[ ]?[0-9]{1,2})?$/.test(field)
        // if (result) {
        //   const ibanStripped = field.replace(/[^A-Z0-9]+/gi, '').toUpperCase()
        //   const m = ibanStripped.match(/^([A-Z]{2})([0-9]{2})([A-Z0-9]{9,30})$/)
        //   if (!m) return true //error
        //   const numbericed = (m[3] + m[1] + m[2]).replace(/[A-Z]/g, (ch) => (ch.charCodeAt(0) - 55))
        //   const mod97 = numbericed.match(/\d{1,7}/g).reduce((total, curr) => { return (Number(total + curr) % 97) }, '')
        //   return !(mod97 === 1)
        // }
        if (!field || field.length < 20) return true
        return false
      } else if (type === 'bic') {
        // eslint-disable-next-line
        // const result = /^[A-Z]{2}[0-9]{2}(?:[ ]?[0-9]{4}){4}(?:[ ]?[0-9]{1,2})?$/.test(field)
        // return !result
        if (!field || field.length < 8) return true
        return false
      } else if (type === 'cb') {
        // eslint-disable-next-line
        let result = /^\d+$/.test(field)
        if (result) {
          result = (field.length >= 16)
        }
        return !result
      } else if (type === 'cryptogramme') {
        // eslint-disable-next-line
        let result = /^\d+$/.test(field)
        if (result) {
          result = (field.length >= 3 && field.length <= 4)
        }
        return !result
      }

      return false
    }
  }
}
